import { subscribeToRecordingStatus } from '../../background/services'
import { deleteWebcam, startWebcam } from './webcamControls'
import {
    addCursorHighlights,
    removeCursorHighlights,
} from './cursorHighlightControls'
import {
    injectRecControls,
    deleteRecControls,
    enableProcessingState,
} from './injectRecControls'
import { RecordingStatus } from '../../types'

export const recStatusObserver = orgData => {
    let prevStatus: RecordingStatus | null = null

    subscribeToRecordingStatus(({ status }) => {
        // On status change
        if (status !== prevStatus) {
            if (status === 'recording') {
                // Do not await for rec controls so other functionality can be rendered in parallel
                injectRecControls('playbook', orgData, prevStatus !== null)
                startWebcam()
                addCursorHighlights()
            }

            // Show spinner
            if (status === 'processing') {
                deleteWebcam()
                removeCursorHighlights()
                enableProcessingState()
            }

            // On processing finished
            if (prevStatus === 'processing') {
                deleteRecControls()
            }
        }

        prevStatus = status
    })
}
